export default {
  social: {
    PROD_FB: "454527232684177",
    DEV_FB: "967428660476810"
  }
};
